var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-1.5 rounded-full flex w-full bg-gray-15"},[_c('div',{staticClass:"bg-blue-600 h-full rounded-full",style:({ width: _vm.width })})])}
var staticRenderFns = []

export { render, staticRenderFns }